module.exports = "#time-picker[_nghost-c8] .time-picker-footer[_ngcontent-c8] button[_ngcontent-c8] {\n  background: #015d7e !important; }\n\na:hover {\n  color: #40b0d8; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/employee-slots/employee-slots.component.scss
// module id = ./src/app/admin/employee-slots/employee-slots.component.scss
// module chunks = main